/* eslint-disable no-case-declarations */
import { IAction } from '../model/IAction';

import * as ProcessVariableActions from '../actions/ProcessVariableActions';
import { IProcessVariable } from "../model/IProcessData";

export function processVariables(state: IProcessVariable[] = [], action: IAction): IProcessVariable[] {
    switch (action.type) {
        case ProcessVariableActions.RECEIVE_PROCESS_VARIABLES:
            const receiveProcessVariableNameAction = action as ProcessVariableActions.ReceiveProcessVariablesAction;

            if (!receiveProcessVariableNameAction.processVariables) {
                return [];
            }

            return receiveProcessVariableNameAction.processVariables.map((processVariable, index) => {
                const mode = processVariable.mode ?? 'json';

                return {
                    id: index,
                    name: processVariable.name,
                    value: processVariable.value,
                    displayValue: getProcessVariableDisplayValue(processVariable.value, mode),
                    isSecret: processVariable.isSecret,
                    mode: mode,
                    description: processVariable.description ?? '',
                };
            });
        case ProcessVariableActions.ADD_PROCESS_VARIABLE:
            const value = JSON.stringify("");
            const mode = 'text';

            return [...state, {
                id: state.length,
                name: "variable",
                value: value,
                displayValue: getProcessVariableDisplayValue(value, mode),
                isSecret: false,
                mode: mode,
                description: '',
            }];
        case ProcessVariableActions.UPDATE_PROCESS_VARIABLE_NAME:
            const updateProcessVariableNameAction = action as ProcessVariableActions.UpdateProcessVariableNameAction;
            return state.map((processVariable) => {
                if (processVariable.id != updateProcessVariableNameAction.id) {
                    return processVariable;
                }
                processVariable.name = updateProcessVariableNameAction.newName;
                return processVariable;
            });

        case ProcessVariableActions.UPDATE_PROCESS_VARIABLE_VALUE:
            const updateProcessVariableValueAction = action as ProcessVariableActions.UpdateProcessVariableValueAction;
            return state.map((processVariable) => {
                if (processVariable.id != updateProcessVariableValueAction.id) {
                    return processVariable;
                }

                processVariable.displayValue = updateProcessVariableValueAction.newDisplayValue;
                processVariable.value = getProcessVariableValue(updateProcessVariableValueAction.newDisplayValue, processVariable.mode);

                return processVariable;
            });
        case ProcessVariableActions.UPDATE_PROCESS_VARIABLE_MODE:
            const updateProcessVariableModeAction = action as ProcessVariableActions.UpdateProcessVariableModeAction;
            return state.map((processVariable) => {
                if (processVariable.id != updateProcessVariableModeAction.id) {
                    return processVariable;
                }

                processVariable.mode = updateProcessVariableModeAction.newMode;
                processVariable.value = getProcessVariableValue(processVariable.displayValue, processVariable.mode);
                return processVariable;
            });
        case ProcessVariableActions.UPDATE_PROCESS_VARIABLE_DESCRIPTION:
            const updateProcessVariableDescriptionAction = action as ProcessVariableActions.UpdateProcessVariableDescriptionAction;
            return state.map((processVariable) => {
                if (processVariable.id != updateProcessVariableDescriptionAction.id) {
                    return processVariable;
                }
                processVariable.description = updateProcessVariableDescriptionAction.newDescription;
                return processVariable;
            });
        case ProcessVariableActions.TOGGLE_PROCESS_VARIABLE_IS_SECRET:
            const toggleProcessVariableIsSecretAction = action as ProcessVariableActions.ToggleProcessVariableIsSecretAction;
            return state.map((processVariable) => {
                if (processVariable.id != toggleProcessVariableIsSecretAction.id) {
                    return processVariable;
                }
                processVariable.isSecret = !processVariable.isSecret;
                return processVariable;
            });
        case ProcessVariableActions.REMOVE_PROCESS_VARIABLE:
            const removeProcessVariableAction = action as ProcessVariableActions.RemoveProcessVariableAction;
            return state.filter(processVariable => processVariable.id != removeProcessVariableAction.id)
                .map((processVariable, index) => {
                    return {
                        id: index, // Maintain ids as 0, 1, ..., n
                        name: processVariable.name,
                        value: processVariable.value,
                        displayValue: processVariable.displayValue,
                        isSecret: processVariable.isSecret,
                        mode: processVariable.mode,
                    }
                });
        case ProcessVariableActions.REORDER_PROCESS_VARIABLES:
            const reorderProcessVariablesAction = action as ProcessVariableActions.ReorderProcessVariablesAction;

            const a = reorderProcessVariablesAction.oldIndex;
            const b = reorderProcessVariablesAction.newIndex;

            const newState = [...state];

            [newState[a], newState[b]] = [newState[b], newState[a]];

            newState[a].id = a;
            newState[b].id = b;

            return newState;
        default:
            return state;
    }
}

const isTextLiteral = (value: string, mode: string | undefined): boolean => mode === 'text' && !value.toUpperCase().startsWith("#ENV");

export const getProcessVariableValue = (displayValue: string, mode: string | undefined): string => isTextLiteral(displayValue, mode) ? JSON.stringify(displayValue) : displayValue;

export const getProcessVariableDisplayValue = (value: string, mode: string | undefined): string => isTextLiteral(value, mode) ? JSON.parse(value) : value;
